import React, {ReactElement, ReactNode} from 'react';
import {IElementStaticList} from '../../../incase-domain/elements/staticList';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';
import {getBorderStyle} from '../../../utils/style.utils';

interface ElementStaticListComponentProps {
    element: IElementStaticList;
    device?: DeviceType;
}

function ElementStaticListComponent(props: ElementStaticListComponentProps): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;

    function renderList(ordered: boolean, itemGenerator: (value: string, index: number, array: string[]) => ReactNode): JSX.Element {
        if (ordered) {
            return <ol className={`${getElementClasses(device)} c-listElement--ordered`}>{element.items.map(itemGenerator)}</ol>;
        }
        return <ul className={getElementClasses(device)}>{element.items.map(itemGenerator)}</ul>;
    }

    return (
        <div style={getElementStyle(device, element)}>
            {renderList(element.ordered, (item, index) => {
                return <li key={`item-key-${element.id}-${index}`}>{item}</li>;
            })}
        </div>
    );
}

function getElementStyle(device: DeviceType, element: IElementStaticList): React.CSSProperties {
    if (device === DeviceType.MOBILE) {
        return {
            background: element.color,
            color: element.font.color,
            fontFamily: element.fontFamily?.name,
            borderRadius: getBorderStyle(element.borderRadius),
        };
    }

    return {
        fontSize: `${element.font.size}em`,
        background: element.color,
        color: element.font.color,
        fontFamily: element.fontFamily?.name,
        borderRadius: getBorderStyle(element.borderRadius),
    };
}

function getElementClasses(device: DeviceType): string {
    if (device === DeviceType.MOBILE) {
        return 'c-listElement c-listElement--mobile';
    }

    return 'c-listElement';
}

export default ElementStaticListComponent;
